// Fallback data used when the API is unavailable
export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5010';

export const fallbackPortfolio = [
  // ── OUR PRODUCTS (is_product: 1) — shown first ───────────────────────────────
  // Real product images sourced from techiesitsolutions.com Cloudinary CDN

  {
    id: 11,
    title: 'Techies School Management System',
    category: 'WEB', icon: '🏫', color: '#3b82f6', is_product: 1,
    description: 'Complete School Management System with role-based dashboards for admin, teachers, students & parents. Includes fee management, attendance, timetable, exams, notices and more.',
    image_url: 'https://res.cloudinary.com/djrgnbstc/image/upload/v1777011723/techies-portfolio/jnpkbegbznrdx2hlydcm.png',
    video_url: '',
    tech_stack: ['Django', 'Python', 'PostgreSQL', 'Bootstrap'],
    features: [
      { text: 'Role-based dashboards (Admin, Teacher, Student, Parent)', ok: true },
      { text: 'Fee collection & payment tracking', ok: true },
      { text: 'Attendance management with reports', ok: true },
      { text: 'Exam & result management', ok: true },
      { text: 'Timetable & schedule builder', ok: true },
      { text: 'Notice board & announcements', ok: true },
    ],
    project_date: '2024', client: 'Techies Private Higher Secondary School',
    project_url: 'https://sms.bonefracturecrackdetection.online',
  },
  {
    id: 12,
    title: 'GYMPRO - Gym Management System',
    category: 'WEB', icon: '💪', color: '#f59e0b', is_product: 1,
    description: 'Complete gym management platform with AI workout plans, QR attendance, member tracking, payment management, trainer scheduling and performance analytics.',
    image_url: 'https://res.cloudinary.com/djrgnbstc/image/upload/v1777012145/techies-portfolio/cx5xmaq2wtkshdioshxi.png',
    video_url: '',
    tech_stack: ['Django', 'Python', 'MySQL', 'Tailwind CSS'],
    features: [
      { text: 'Member enrollment & subscription plans', ok: true },
      { text: 'QR code based attendance system', ok: true },
      { text: 'AI-powered workout plan generator', ok: true },
      { text: 'Trainer scheduling & assignment', ok: true },
      { text: 'Payment & billing management', ok: true },
      { text: 'Performance analytics dashboard', ok: true },
    ],
    project_date: '2024', client: 'GymPro Fitness',
    project_url: 'https://gms.bonefracturecrackdetection.online',
  },
  {
    id: 13,
    title: 'TileCraft ERP - Marble & Tile ERP',
    category: 'WEB', icon: '🏗️', color: '#8b5cf6', is_product: 1,
    description: 'Enterprise Resource Planning for the marble and tile industry. Manages inventory, production, billing, dispatch, vendor relationships and reporting in one platform.',
    image_url: 'https://res.cloudinary.com/djrgnbstc/image/upload/v1782473896/techies-portfolio/pfcbqfhp5terrfq17iek.png',
    video_url: '',
    tech_stack: ['PHP', 'Laravel', 'MySQL', 'Bootstrap'],
    features: [
      { text: 'Inventory & stock management', ok: true },
      { text: 'Production order tracking', ok: true },
      { text: 'Billing & invoicing module', ok: true },
      { text: 'Dispatch & delivery tracking', ok: true },
      { text: 'Vendor & purchase management', ok: true },
      { text: 'Business analytics & reports', ok: true },
    ],
    project_date: '2024', client: 'DecorHub Pro',
    project_url: 'https://decorhubpro.com/marble_erp/login',
  },
  {
    id: 14,
    title: 'LedgerPro KhataBook',
    category: 'WEB', icon: '📒', color: '#10b981', is_product: 1,
    description: 'Secure business accounting system with JWT authentication and 99.9% uptime. Features invoicing, expense tracking, ledger management, GST reports and business analytics.',
    image_url: 'https://res.cloudinary.com/djrgnbstc/image/upload/v1777012291/techies-portfolio/davoapftc0admk9ztray.png',
    video_url: '',
    tech_stack: ['Django', 'Python', 'PostgreSQL', 'Chart.js'],
    features: [
      { text: 'Double-entry bookkeeping ledger', ok: true },
      { text: 'GST invoice generation', ok: true },
      { text: 'Expense & income tracking', ok: true },
      { text: 'Business profit/loss reports', ok: true },
      { text: 'JWT secured authentication', ok: true },
      { text: 'Multi-user access control', ok: true },
    ],
    project_date: '2024', client: 'KhataBook Business Solutions',
    project_url: 'https://khatabook.bonefracturecrackdetection.online',
  },
  {
    id: 15,
    title: 'EMS Dashboard - Employee Management',
    category: 'WEB', icon: '👔', color: '#e74c3c', is_product: 1,
    description: 'Full-featured Employee Management System with role-based dashboards. Handles HR workflows, payroll processing, leave management, performance tracking and attendance.',
    image_url: 'https://res.cloudinary.com/djrgnbstc/image/upload/v1777011835/techies-portfolio/fqs78d2q0k0rhhs3cfil.png',
    video_url: '',
    tech_stack: ['Django', 'Python', 'PostgreSQL', 'Bootstrap'],
    features: [
      { text: 'Employee onboarding & profiles', ok: true },
      { text: 'Attendance & leave management', ok: true },
      { text: 'Payroll & salary processing', ok: true },
      { text: 'Performance appraisal system', ok: true },
      { text: 'Role-based access (HR, Manager, Employee)', ok: true },
      { text: 'Reports & HR analytics', ok: true },
    ],
    project_date: '2024', client: 'Corporate HR Solutions',
    project_url: 'http://ems.bonefracturecrackdetection.online',
  },

  // ── NEW PRODUCTS from Techies IT Solutions ─────────────────────────────────

  {
    id: 16,
    title: 'MediCare HMS - Hospital Management',
    category: 'WEB', icon: '🏥', color: '#ef4444', is_product: 1,
    description: 'Comprehensive Hospital Management System with OPD/IPD management, doctor scheduling, pharmacy, lab reports, billing and complete patient records.',
    image_url: 'https://res.cloudinary.com/djrgnbstc/image/upload/v1777012066/techies-portfolio/q3l6or9ob103hq4osvlx.png',
    video_url: '',
    tech_stack: ['Django', 'Python', 'PostgreSQL', 'Bootstrap'],
    features: [
      { text: 'OPD & IPD patient management', ok: true },
      { text: 'Doctor & staff scheduling', ok: true },
      { text: 'Pharmacy & medicine inventory', ok: true },
      { text: 'Lab test & report management', ok: true },
      { text: 'Billing & insurance claims', ok: true },
      { text: 'Patient medical history & records', ok: true },
    ],
    project_date: '2024', client: 'MediCare Hospital Solutions',
    project_url: '#',
  },
  {
    id: 17,
    title: 'Home Decor Hub',
    category: 'WEB', icon: '🛋️', color: '#d97706', is_product: 1,
    description: 'Feature-rich e-commerce platform for home decor and furniture. Includes product catalog, 3D room visualizer, wishlist, order tracking, and seller dashboard.',
    image_url: 'https://res.cloudinary.com/djrgnbstc/image/upload/v1777011360/techies-portfolio/gl5bc8rbww5a6wd7iw4h.png',
    video_url: '',
    tech_stack: ['React', 'Node.js', 'MongoDB', 'Stripe'],
    features: [
      { text: 'Product catalog with advanced filters', ok: true },
      { text: '3D room visualization tool', ok: true },
      { text: 'Wishlist & comparison feature', ok: true },
      { text: 'Secure payment gateway integration', ok: true },
      { text: 'Order tracking & notifications', ok: true },
      { text: 'Seller & admin dashboard', ok: true },
    ],
    project_date: '2024', client: 'Home Decor Hub',
    project_url: '#',
  },
  {
    id: 18,
    title: 'Ecom Market - E-Commerce Platform',
    category: 'WEB', icon: '🛒', color: '#0ea5e9', is_product: 1,
    description: 'Full-stack multi-vendor e-commerce marketplace with product management, cart, secure checkout, order management, reviews and comprehensive seller analytics.',
    image_url: 'https://res.cloudinary.com/djrgnbstc/image/upload/v1777017832/techies-portfolio/la9zrjgni95ue8yzokh6.png',
    video_url: '',
    tech_stack: ['React', 'Node.js', 'MySQL', 'Razorpay'],
    features: [
      { text: 'Multi-vendor marketplace', ok: true },
      { text: 'Product management & catalog', ok: true },
      { text: 'Secure cart & checkout', ok: true },
      { text: 'Order management & tracking', ok: true },
      { text: 'Rating & review system', ok: true },
      { text: 'Seller analytics dashboard', ok: true },
    ],
    project_date: '2024', client: 'Ecom Market Solutions',
    project_url: '#',
  },
  {
    id: 19,
    title: 'Vendor Management System',
    category: 'WEB', icon: '🤝', color: '#7c3aed', is_product: 1,
    description: 'End-to-end vendor management system for procurement and supply chain. Manages vendor onboarding, purchase orders, invoice tracking, performance scoring and compliance.',
    image_url: 'https://res.cloudinary.com/djrgnbstc/image/upload/v1777528121/techies-portfolio/jgfxs3sotwujrrsm0l7z.png',
    video_url: '',
    tech_stack: ['Laravel', 'PHP', 'MySQL', 'Bootstrap'],
    features: [
      { text: 'Vendor onboarding & KYC', ok: true },
      { text: 'Purchase order management', ok: true },
      { text: 'Invoice & payment tracking', ok: true },
      { text: 'Vendor performance scoring', ok: true },
      { text: 'Compliance & document management', ok: true },
      { text: 'Supply chain analytics', ok: true },
    ],
    project_date: '2025', client: 'Vendor Management Solutions',
    project_url: '#',
  },
  {
    id: 20,
    title: 'Smart Laundry Service',
    category: 'WEB', icon: '👕', color: '#06b6d4', is_product: 1,
    description: 'On-demand smart laundry management platform with order booking, pickup/delivery scheduling, real-time order tracking, payment integration and customer loyalty system.',
    image_url: 'https://res.cloudinary.com/djrgnbstc/image/upload/v1777018398/techies-portfolio/mtlyisfnmpmutdsvhsmn.png',
    video_url: '',
    tech_stack: ['React', 'Node.js', 'MongoDB', 'Stripe'],
    features: [
      { text: 'Online laundry order booking', ok: true },
      { text: 'Pickup & delivery scheduling', ok: true },
      { text: 'Real-time order status tracking', ok: true },
      { text: 'Multiple service category pricing', ok: true },
      { text: 'Payment gateway integration', ok: true },
      { text: 'Customer loyalty & rewards', ok: true },
    ],
    project_date: '2025', client: 'Smart Laundry Solutions',
    project_url: '#',
  },
  {
    id: 21,
    title: 'Document Reminder System',
    category: 'WEB', icon: '📄', color: '#f97316', is_product: 1,
    description: 'Automated document expiry reminder system for businesses. Manages licenses, certificates, insurance renewals with smart notifications, calendar view and compliance tracking.',
    image_url: 'https://techiesitsolutions.com/assets/Document%20Reminder%20System.png',
    video_url: '',
    tech_stack: ['Django', 'Python', 'PostgreSQL', 'Celery'],
    features: [
      { text: 'Document expiry tracking', ok: true },
      { text: 'Automated email & SMS reminders', ok: true },
      { text: 'Calendar view & timeline', ok: true },
      { text: 'Multiple document categories', ok: true },
      { text: 'Team & department management', ok: true },
      { text: 'Compliance reporting dashboard', ok: true },
    ],
    project_date: '2025', client: 'Document Compliance Solutions',
    project_url: '#',
  },
  {
    id: 22,
    title: 'Warehouse Management System',
    category: 'WEB', icon: '🏭', color: '#64748b', is_product: 1,
    description: 'Complete warehouse management system with inventory control, barcode scanning, inward/outward management, stock transfers, expiry tracking and real-time warehouse analytics.',
    image_url: 'https://techiesitsolutions.com/assets/Warehouse%20Management%20System.png',
    video_url: '',
    tech_stack: ['Laravel', 'PHP', 'MySQL', 'Bootstrap'],
    features: [
      { text: 'Inventory & stock management', ok: true },
      { text: 'Barcode & QR code scanning', ok: true },
      { text: 'Inward & outward management', ok: true },
      { text: 'Stock transfer & adjustment', ok: true },
      { text: 'Expiry date & batch tracking', ok: true },
      { text: 'Warehouse analytics & reports', ok: true },
    ],
    project_date: '2025', client: 'Warehouse Solutions',
    project_url: '#',
  },
  {
    id: 23,
    title: 'Sanitary & Tiles Software',
    category: 'WEB', icon: '🧱', color: '#84cc16', is_product: 1,
    description: 'Specialized business management software for sanitary and tiles dealers. Handles product catalog, quotations, orders, installation scheduling, and customer management.',
    image_url: 'https://res.cloudinary.com/djrgnbstc/image/upload/v1782473896/techies-portfolio/pfcbqfhp5terrfq17iek.png',
    video_url: '',
    tech_stack: ['PHP', 'Laravel', 'MySQL', 'Bootstrap'],
    features: [
      { text: 'Product catalog with variants', ok: true },
      { text: 'Quotation & estimate builder', ok: true },
      { text: 'Order & delivery management', ok: true },
      { text: 'Installation scheduling', ok: true },
      { text: 'Customer & dealer management', ok: true },
      { text: 'GST billing & reports', ok: true },
    ],
    project_date: '2025', client: 'Sanitary & Tiles Business',
    project_url: '#',
  },

  // ── CLIENT PROJECTS (is_product: 0) ──────────────────────────────────────────
  {
    id: 1, title: 'GLOBAL Speciality Hospital', category: 'WEB', icon: '🏥', color: '#e74c3c',
    is_product: 0,
    description: 'Healthcare web portal with appointment booking system, doctor profiles, and patient management.',
    image_url: 'https://saanviinnovation.com/assets/img/portfolio/portfolio-1.jpg',
    video_url: '',
    tech_stack: ['React', 'Node.js', 'MySQL'],
    features: [],
    project_date: '2023', client: 'Global Hospital Gwalior',
    project_url: 'https://globalshospital.com',
  },
  {
    id: 2, title: 'Laxman Education - By Hanu Sir', category: 'WEB', icon: '📚', color: '#3498db',
    is_product: 0,
    description: 'E-learning platform with video courses, live sessions, study material downloads and student dashboards.',
    image_url: 'https://saanviinnovation.com/assets/img/portfolio/portfolio-2.jpg',
    video_url: '',
    tech_stack: ['PHP', 'MySQL', 'Bootstrap'],
    features: [],
    project_date: '2023', client: 'Laxman Education Institute',
    project_url: '#',
  },
  {
    id: 3, title: 'Welcome To Muktidham', category: 'WEB', icon: '🏛️', color: '#9b59b6',
    is_product: 0,
    description: 'Spiritual trust website with event management, gallery, donation portal, and seva booking.',
    image_url: 'https://saanviinnovation.com/assets/img/portfolio/portfolio-3.jpg',
    video_url: '',
    tech_stack: ['WordPress', 'PHP', 'MySQL'],
    features: [],
    project_date: '2023', client: 'Muktidham Trust Gwalior',
    project_url: '#',
  },
  {
    id: 4, title: 'JugadGuru .com', category: 'APP', icon: '💡', color: '#f39c12',
    is_product: 0,
    description: 'Innovation platform connecting creators with opportunities. Features project collaboration, mentorship, and funding connections.',
    image_url: 'https://saanviinnovation.com/assets/img/portfolio/portfolio-4.jpg',
    video_url: '',
    tech_stack: ['React Native', 'Node.js'],
    features: [],
    project_date: '2023', client: 'JugadGuru Platform',
    project_url: '#',
  },
  {
    id: 5, title: 'Welcome To Rashtriya Military School', category: 'WEB', icon: '🎖️', color: '#27ae60',
    is_product: 0,
    description: 'Official school website with online admissions, results, news updates and alumni management.',
    image_url: 'https://saanviinnovation.com/assets/img/portfolio/portfolio-5.jpg',
    video_url: '',
    tech_stack: ['React', 'PHP', 'MySQL'],
    features: [],
    project_date: '2023', client: 'RMS Gwalior',
    project_url: '#',
  },
  {
    id: 6, title: 'Dr. Dalmia Heart Wellness Centre', category: 'WEB', icon: '❤️', color: '#e91e63',
    is_product: 0,
    description: 'Cardiac wellness centre with online consultation booking, doctor profiles, and health tips blog.',
    image_url: 'https://saanviinnovation.com/assets/img/portfolio/portfolio-6.jpg',
    video_url: '',
    tech_stack: ['HTML5', 'CSS3', 'JavaScript'],
    features: [],
    project_date: '2023', client: 'Dalmia Heart Centre',
    project_url: '#',
  },
  {
    id: 7, title: 'Malwa Vikas Mandal', category: 'WEB', icon: '🌱', color: '#00bcd4',
    is_product: 0,
    description: 'Community development organization portal with member management, events, and volunteer registration.',
    image_url: 'https://saanviinnovation.com/assets/img/portfolio/portfolio-7.jpg',
    video_url: '',
    tech_stack: ['WordPress', 'PHP'],
    features: [],
    project_date: '2023', client: 'Malwa Vikas Mandal',
    project_url: '#',
  },
  {
    id: 8, title: 'Sanskar Valley Public School', category: 'WEB', icon: '🏫', color: '#ff5722',
    is_product: 0,
    description: 'School management system with student portal, fee management, timetable, and parent communication.',
    image_url: 'https://saanviinnovation.com/assets/img/portfolio/portfolio-8.jpg',
    video_url: '',
    tech_stack: ['React', 'Node.js', 'MySQL'],
    features: [],
    project_date: '2023', client: 'Sanskar Valley Public School',
    project_url: '#',
  },
  {
    id: 9, title: 'ATAL BAL PALAK, Gwalior (M.P)', category: 'APP', icon: '👶', color: '#8bc34a',
    is_product: 0,
    description: 'Child welfare app - PARVARISH SUNHARE KAL KI. Tracks child development, connects parents with care resources.',
    image_url: 'https://saanviinnovation.com/assets/img/portfolio/portfolio-9.jpg',
    video_url: '',
    tech_stack: ['React Native', 'Firebase'],
    features: [],
    project_date: '2023', client: 'ATAL BAL PALAK',
    project_url: '#',
  },
  {
    id: 10, title: 'AB PRO - Best Build Quality', category: 'APP', icon: '🔧', color: '#607d8b',
    is_product: 0,
    description: 'Premium construction & build quality showcase app with project gallery, material catalog, and contractor profiles.',
    image_url: 'https://saanviinnovation.com/assets/img/portfolio/portfolio-10.jpg',
    video_url: '',
    tech_stack: ['Flutter', 'Firebase'],
    features: [],
    project_date: '2023', client: 'AB PRO Construction',
    project_url: '#',
  },
];

export const fallbackServices = [
  { id:1, icon:'💻', title:'Website Development',       description:'Custom websites built with modern technologies for optimal performance and user experience.' },
  { id:2, icon:'🎨', title:'Website Design',            description:'Stunning UI/UX designs that capture your brand essence and engage visitors effectively.' },
  { id:3, icon:'📈', title:'Digital Marketing',         description:'Data-driven digital marketing strategies to grow your online presence and ROI.' },
  { id:4, icon:'🔍', title:'SEO',                       description:'Search engine optimization to rank higher, drive organic traffic and increase conversions.' },
  { id:5, icon:'📱', title:'Social Media Optimization', description:'Optimize your social media profiles for maximum reach and engagement across platforms.' },
  { id:6, icon:'📣', title:'Social Media Marketing',    description:'Strategic social media campaigns that build brand awareness and loyal customer communities.' },
];

export const fallbackPricing = [
  { id:1, category:'Website Development',       name:'Static Website',  price:'5,000',  is_featured:0, icon:'🌐', tag:'Starter',   features:[{text:'Static Website',ok:true},{text:'5 Webpages',ok:true},{text:'Domain',ok:true},{text:'Hosting',ok:true},{text:'Responsive',ok:true},{text:'Dynamic Features',ok:false}] },
  { id:2, category:'Website Development',       name:'Dynamic Website', price:'10,000', is_featured:1, icon:'💻', tag:'Popular',   features:[{text:'Dynamic Website',ok:true},{text:'6 Webpages',ok:true},{text:'Domain & Hosting',ok:true},{text:'CMS Panel',ok:true},{text:'Basic SEO',ok:true},{text:'Contact Form',ok:true}] },
  { id:3, category:'Search Engine Optimization',name:'SEO Package',     price:'25,000', is_featured:0, icon:'🔍', tag:'Advanced',  features:[{text:'Full Website SEO',ok:true},{text:'50+ Locations',ok:true},{text:'Domain & Hosting',ok:true},{text:'Keyword Research',ok:true},{text:'Monthly Reports',ok:true}] },
  { id:4, category:'Logo Design',               name:'Logo Design',     price:'500',    is_featured:1, icon:'🎨', tag:'Design',    features:[{text:'Custom Logo',ok:true},{text:'3 Concepts',ok:true},{text:'Unlimited Revisions',ok:true},{text:'PNG & SVG',ok:true}] },
  { id:5, category:'Google Business',           name:'Google Business', price:'5,000',  is_featured:0, icon:'📍', tag:'Local SEO', features:[{text:'GMB Setup',ok:true},{text:'Profile Optimization',ok:true},{text:'Photos & Posts',ok:true},{text:'Local SEO Boost',ok:true}] },
  { id:6, category:'Ecommerce CMS',             name:'Ecommerce CMS',   price:'10,000', is_featured:0, icon:'🛒', tag:'E-Commerce',features:[{text:'Full Store',ok:true},{text:'Product Management',ok:true},{text:'Payment Gateway',ok:true},{text:'Admin Dashboard',ok:true}] },
];
